import request from '@/utils/request'
export function getHistory() {
    return request({
        url: 'home-request/history',
        method: 'post'

    })
}

export function getActiveSessions() {
    return request({
        url: 'home-request/active',
        method: 'post'

    })
}

export function cancelEjareRequest(serial) {
    return request({
        url: 'ejare/cancel',
        method: 'post',
        data: { FSerial: serial }

    })
}

export function confirmEjare(serial, confirm) {
    return request({
        url: 'ejare/guarantorsConfirm',
        method: 'post',
        data: { confirm: confirm, srlRent: serial }
    })
}

export function checkEjareApplyPermission() {
    return request({
        url: 'ejare/checkApplyPermission',
        method: 'post'

    })
}

export function saveEjareRequest(file, serial, guarantor1, guarantor2, rentStartDate, rentEndDate, cash, rent, rentType, address, tel) {

    var fmData = new FormData();

    let fileName = file == null ? null : file.name
    fmData.append('FSerial', serial)
    fmData.append('Guarantor1', guarantor1)
    fmData.append('Guarantor2', guarantor2)
    fmData.append('RentStartDate', rentStartDate)
    fmData.append('RentEndDate', rentEndDate)
    fmData.append('Cash', cash)
    fmData.append('Rent', rent)
    fmData.append('RentType', rentType)
    fmData.append('Address', address)
    fmData.append('Tel', tel)
    fmData.append('image', file)
    fmData.append('fileName', fileName)

    return request({
        url: 'ejare/save',
        method: 'post',
        data: fmData

    })

}
export function removeBuyRequest(serial) {
    return request({
        url: 'HomeBuy/remove',
        method: 'post',
        data: { FSerial: serial }

    })
}

export function confirmBuy(serial, confirm) {
    return request({
        url: 'HomeBuy/guarantorsConfirm',
        method: 'post',
        data: { confirm: confirm, requestID: serial }
    })
}

export function checkBuyApplyPermission() {
    return request({
        url: 'HomeBuy/checkApplyPermission',
        method: 'post'

    })
}

export function saveBuyRequest(files, serial, guarantor1, guarantor2, startDate, cash, address, tel) {

    var fmData = new FormData();

    fmData.append('FSerial', serial)
    fmData.append('Guarantor1', guarantor1)
    fmData.append('Guarantor2', guarantor2)
    fmData.append('DateBuyHome', startDate)
    fmData.append('CostBuyHome', cash)
    fmData.append('AddressHome', address)
    fmData.append('Tel', tel)
    for (let i = 0; i < files.length; i++) {
        let file = files[i];
        let fileName = file == null ? null : file.name
        fmData.append('File' + (i + 1), file)
        fmData.append('FileName' + (i + 1), fileName)
    }
    return request({
        url: 'HomeBuy/save',
        method: 'post',
        data: fmData

    })
}